import PDMPlpSearch from "@tw/product-discovery-merchandizing-cra/lib/plp/search/search-master-nextjs";
import PageWrapper from "../wrappers/page-wrapper";

PDMPlpSearch.domainName = "product-discovery";

export default PageWrapper(PDMPlpSearch);
